import { render } from "./ModalCustomizeKpis.vue?vue&type=template&id=b0d51808&scoped=true"
import script from "./ModalCustomizeKpis.vue?vue&type=script&lang=js"
export * from "./ModalCustomizeKpis.vue?vue&type=script&lang=js"

import "./ModalCustomizeKpis.vue?vue&type=style&index=0&id=b0d51808&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d51808"]])

export default __exports__